module.exports = __webpack_public_path__ + "img/arcadead2.13a48a25.jpg";